// When casting doesn't take the actor's country (docs/16 §9, decided 2026-11-02): step 2's
// Continue, and step 4's Send after a countryNotEligible refusal, give way to the only two
// useful exits: the casting calls in the actor's own country, or their dashboard.

import { goToDashboard } from "./dashboard";
import { trackSubmissionEvent } from "../analytics";

export const COUNTRY_NOT_ELIGIBLE = "countryNotEligible";

export type CountryClosedStep = "materials" | "review";

// Their country's list, /submission/casting-calls/MX. The API honours the country within its
// switch policy (CA, US and MX browse each other; anyone else gets their IP's country). With no
// country known: the list the API picks from the IP.
export const castingCallsPathFor = (countryCode?: string | null): string => {
  const code = (countryCode || "").trim().toUpperCase();
  return /^[A-Z]{2}$/.test(code) ? `/submission/casting-calls/${code}` : "/submission/casting-calls";
};

export const trackCountryClosedShown = (step: CountryClosedStep) =>
  trackSubmissionEvent("sf_country_not_eligible_shown", { at: step });

export const leaveForCastingCalls = (
  history: { push: (path: string) => void },
  countryCode: string | null | undefined,
  step: CountryClosedStep
) => {
  trackSubmissionEvent("sf_country_not_eligible_exit", { choice: "castingCalls", at: step });
  history.push(castingCallsPathFor(countryCode));
};

export const leaveForDashboard = (history: { push: (path: string) => void }, step: CountryClosedStep) => {
  trackSubmissionEvent("sf_country_not_eligible_exit", { choice: "dashboard", at: step });
  goToDashboard(history);
};
